import { Component, Inject, inject, Input, Optional } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-rapid-consent-modal',
	templateUrl: './rapid-consent-modal.component.html',
	styleUrls: ['./rapid-consent-modal.component.scss'],
	standalone: false,
})
export class RapidConsentModalComponent {
	@Input() application: any = null;

	private readonly _onDestroy = new Subject<void>();

	// Single Formly model (PascalCase keys matching Zoho CRM)
	private readonly dialog = inject(MatDialog);

	constructor(
		public dialogRef: MatDialogRef<RapidConsentModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
	) { dialogRef.disableClose = true; }

		protected onConfirm(): void {
		this.dialogRef.close(true);
	}

	protected onDismiss(): void {
		this.dialogRef.close(false);
	}
}
